export default "__VITE_ASSET__D9eg7rKf__"